import { useMutation } from '@tanstack/react-query';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import {
  KeycloakTokenResponseDto,
  MutationOptions,
  MutationResult,
} from '@thingslog/repositories';
import { QueryKeys } from '../enums/QueryKeys';

export interface ApiTokenQueryClient {
  generateApiToken: (body: ApiTokenCredentialsDto) => Promise<KeycloakTokenResponseDto>;
  useGenerateApiToken: (
    options?: MutationOptions<KeycloakTokenResponseDto, ApiTokenCredentialsDto>
  ) => MutationResult<KeycloakTokenResponseDto, ApiTokenCredentialsDto>;
}

export function createApiTokenQueryClient(axios: AxiosInstance): ApiTokenQueryClient {
  return new ApiTokenQueryClientImp(axios);
}

class ApiTokenQueryClientImp {
  public constructor(private axios: AxiosInstance) {}

  public generateApiToken = async (
    body: ApiTokenCredentialsDto
  ): Promise<KeycloakTokenResponseDto> => {
    return await this.axios
      .post(`/api/api-token`, null, {
        params: { clientId: body.clientId, clientSecret: body.clientSecret },
      })
      .then((response: AxiosResponse) => response.data);
  };

  public useGenerateApiToken = (
    options?: MutationOptions<KeycloakTokenResponseDto, ApiTokenCredentialsDto>
  ): MutationResult<KeycloakTokenResponseDto, ApiTokenCredentialsDto> => {
    return useMutation<KeycloakTokenResponseDto, AxiosError, ApiTokenCredentialsDto>(
      [QueryKeys.GenerateApiToken],
      (variables: ApiTokenCredentialsDto) => this.generateApiToken(variables),
      options
    );
  };
}

interface ApiTokenCredentialsDto {
  clientId: string;
  clientSecret: string;
}
